import { Message } from '../../../types/models';
import { MistralMessage, MistralRole } from './types';

export function formatMessagesForMistral(messages: Message[]): MistralMessage[] {
  return messages.map((message) => ({
    role: (message.role || 'user') as MistralRole, // Default to 'user' if undefined
    content: message.content
  }));
}

export function formatMistralResponse(response: MistralMessage): Message {
  return {
    id: crypto.randomUUID(),
    role: response.role,
    content: response.content,
    timestamp: Date.now(),
    modelId: 'mistral-large-latest' // Default model, should be passed as parameter
  };
}